import React from 'react';
import ThemeContext from './ThemeContext';
export default function useTheme() {
  var theme = React.useContext(ThemeContext);

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useDebugValue(theme);
  }

  return theme;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/styles/esm/useTheme/useTheme.js
// module id = 1522
// module chunks = 1